import { render, staticRenderFns } from "./GameBadgePage.vue?vue&type=template&id=1a2c62d8&scoped=true"
import script from "./GameBadgePage.vue?vue&type=script&lang=ts"
export * from "./GameBadgePage.vue?vue&type=script&lang=ts"
import style0 from "./GameBadgePage.vue?vue&type=style&index=0&id=1a2c62d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2c62d8",
  null
  
)

export default component.exports